export const REGULAR_DELIVERY_REGISTER_FILE_NAME = "RegularDelivery";
